import { render, staticRenderFns } from "./AkasseForm.vue?vue&type=template&id=51a98a0f&"
import script from "./AkasseForm.vue?vue&type=script&lang=js&"
export * from "./AkasseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../DM.Umbraco.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports